import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { auth } from '../firebaseConfig';
import { getAdModeFromSearchParams } from '../utils/adLandingIntent';

declare global {
  interface Window {
    clarity?: (...args: unknown[]) => void;
  }
}

export function useClarityTags() {
  const location = useLocation();

  useEffect(() => {
    const clarity = window.clarity;
    if (typeof clarity !== 'function') return;

    const searchParams = new URLSearchParams(location.search);
    const mode = getAdModeFromSearchParams(searchParams) ?? 'organic';
    const authState = auth.currentUser?.emailVerified ? 'in' : 'out';

    clarity('set', 'mode', mode);
    clarity('set', 'auth', authState);

    const utmCampaign = searchParams.get('utm_campaign');
    const utmSource = searchParams.get('utm_source');

    if (utmCampaign) {
      clarity('set', 'utm_campaign', utmCampaign);
    }

    if (utmSource) {
      clarity('set', 'utm_source', utmSource);
    }
  }, [location.key, location.pathname, location.search]);
}

export default useClarityTags;
